export const formatter_ymdhm = new Intl.DateTimeFormat(
  window.navigator.language || "en-US",
  {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  }
);

export const formatter_ymdhms = new Intl.DateTimeFormat(
  window.navigator.language || "en-US",
  {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }
);

export const formatter_month = new Intl.DateTimeFormat(
  window.navigator.language || "en-US",
  {
    month: "long",
  }
);

export const formatter_mon = new Intl.DateTimeFormat(
  window.navigator.language || "en-US",
  {
    month: "short",
  }
);

// "7 Sep 2026, 13:35" — day, short month, year, 24h time, always in this
// order regardless of browser locale (never numeric month/day, never
// 12h/AM-PM) — but the month name itself is locale-aware via formatter_mon
// rather than hardcoded, so it localizes correctly (e.g. "sept." in fr-FR).
export function formatDateTimeLong(timestampMs) {
  const date = new Date(timestampMs);
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");

  return `${date.getDate()} ${formatter_mon.format(date)} ${date.getFullYear()}, ${hh}:${mm}`;
}

// "7 Sep" — day + short month only, no time, no year while it's the
// current one (mobile two-line row meta, README §9).
export function formatDateShort(timestampMs) {
  const date = new Date(timestampMs);
  const year =
    date.getFullYear() === new Date().getFullYear() ? "" : ` ${date.getFullYear()}`;

  return `${date.getDate()} ${formatter_mon.format(date)}${year}`;
}
